var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-date-picker",
    _vm._g(
      _vm._b(
        {
          attrs: {
            "prefix-icon": "yxt-icon-date",
            "default-time": _vm.defaultTime,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm",
            "picker-options": _vm.pickerOptions,
            placeholder: _vm.$t("pc_biz_chooseDate" /* 选择日期时间 */),
            focus: _vm.onFocus,
            clearable: false,
          },
          model: {
            value: _vm.getValue,
            callback: function ($$v) {
              _vm.getValue = $$v
            },
            expression: "getValue",
          },
        },
        "yxt-date-picker",
        _vm.$attrs.attrs,
        false
      ),
      _vm.$attrs.on
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }